export default {
  loading: false,
  config: {}
};
